var map = {
	"./amb-serv.jpg": 3488,
	"./doc-consultation.jpg": 3377,
	"./hom-care.jpg": 7555,
	"./hos-admison.jpg": 6231,
	"./lab-tst.jpg": 150,
	"./med-tour.jpg": 9640
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8461;